module.exports = __webpack_public_path__ + "img/mobile-bg.8512a539.webp";